import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Trans } from "react-i18next";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

const useStyles = makeStyles({
  grid: {},
  imageContainer: {
    width: "100%",
    flexGrow: 0,
  },
  link: {
    boxShadow: "0px 3px 6px #00000029;",
    backgroundColor: "white",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    alignItems: "center",
    color: "#373737",
    textAlign: "center",
    textDecoration: "none",
    "& img": {
      display: "block",
    },
    "& h2": {
      margin: 0,
      textTransform: "uppercase",
      font: "normal normal bold 15px/17px Helvetica",
    },
    "& p": {
      font: "normal normal normal 15px/20px Helvetica",
      textAlign: "center",
      margin: "8px 0 0 0",
      flexGrow: 1,
    },
  },
});

export default ({ data }) => {
  const classes = useStyles();

  return (
    <Container>
      <Grid container spacing={3} direction="row">
        {data.categories
          .filter((category) => category.category != "photobook")
          .map((category) => {
            return (
              <Grid
                container
                size={{ xs: 12, sm: 6, md: 4 }}
                key={category.category}
                className={classes.grid}
                flex={1}
                direction="column"
              >
                <a className={classes.link} href={category.link}>
                  <div className={classes.imageContainer}>
                    <img src={category.image} width={"100%"} />
                  </div>
                  <Box p={2} width={1} flexGrow={1}>
                    <h2>{category.title}</h2>
                    <p>{category.text}</p>
                  </Box>
                </a>
              </Grid>
            );
          })}
      </Grid>
    </Container>
  );
};
